<template lang="pug">
  .display-contents
    slot(
      :label="label"
      :color="color"
      :status="userRecord.status"
      :group="userRecord.group"
    )
</template>

<script>
export default {
  props: {
    userRecord: {
      type: Object, required: true,
    },
  },
  computed: {
    label() {
      if (
        this.userRecord.status === this.$conf.ATTESTATION_STATUSES.excluded
        && !this.userRecord.group
      ) {
        return 'Заявка отклонена';
      }
      if (!this.userRecord.status) {
        return 'Заявка подана';
      }
      return this.$conf.ATTESTATION_STATUSES_TEXT[this.userRecord.status];
    },
    color() {
      const COLORS = {
        [this.$conf.ATTESTATION_STATUSES.excluded]: 'error',
        [this.$conf.ATTESTATION_STATUSES.enrolled]: 'success',
        [this.$conf.ATTESTATION_STATUSES.allowedAttestation]: 'secondary',
        [this.$conf.ATTESTATION_STATUSES.attestated]: 'primary',
        [this.$conf.ATTESTATION_STATUSES.refusedAttestation]: 'warning',
      };
      return COLORS[this.userRecord.status];
    },
  },
};
</script>
